var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-lightbox", attrs: { id: "invoice-details" } },
    [
      _vm.invoice
        ? _c("header", { staticClass: "invoice-toolbar" }, [
            _c("div", { staticClass: "invoice-identity" }, [
              _c(
                "span",
                {
                  staticClass: "invoice-mark",
                  attrs: { "aria-hidden": "true" }
                },
                [
                  _c("portal-icon", {
                    attrs: { name: "receipt-text", size: 19 }
                  })
                ],
                1
              ),
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.$t("invoice.invoice-number-appended", {
                      invoiceNumber: _vm.invoice.invoiceNumberFormatted
                    })
                  )
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "invoice-actions" },
              [
                _vm.$vuetify.breakpoint.mdAndUp
                  ? _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-click": true,
                          "nudge-bottom": 8,
                          "offset-y": "",
                          disabled: !_vm.paymentCount
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "button",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "toolbar-pill history-action",
                                          attrs: {
                                            type: "button",
                                            disabled: !_vm.paymentCount
                                          }
                                        },
                                        "button",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("portal-icon", {
                                        attrs: { name: "history", size: 16 }
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.details.payment-history"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm.paymentCount
                                        ? _c(
                                            "span",
                                            { staticClass: "action-count" },
                                            [_vm._v(_vm._s(_vm.paymentCount))]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2048214639
                        )
                      },
                      [
                        _c("payment-history", {
                          attrs: { invoice: _vm.invoice },
                          on: {
                            openPayment: function($event) {
                              return _vm.openPaymentDetail($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canPay
                  ? _c(
                      "button",
                      {
                        staticClass: "toolbar-pill pay-action",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("invoices.pay-now")
                        },
                        on: { click: _vm.goToPaymentPage }
                      },
                      [
                        _c("portal-icon", {
                          attrs: { name: "credit-card", size: 16 }
                        }),
                        _c("span", { staticClass: "action-label" }, [
                          _vm._v(_vm._s(_vm.$t("invoices.pay-now")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "round-action",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("proposals.print-save-pdf"),
                      title: _vm.$t("proposals.print-save-pdf")
                    },
                    on: { click: _vm.downloadInvoice }
                  },
                  [
                    _c("portal-icon", { attrs: { name: "download", size: 19 } })
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "round-action close-action",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("global.close"),
                      title: _vm.$t("global.close")
                    },
                    on: { click: _vm.handleClose }
                  },
                  [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.invoice || !_vm.account
        ? _c(
            "div",
            { staticClass: "invoice-loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: 38,
                  width: 3,
                  color: "primary"
                }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "invoice-document show-scrollbar" },
            [
              _c(_vm.rendererType, {
                key: _vm.refreshKey,
                tag: "component",
                staticClass: "invoice-renderer-host",
                attrs: {
                  invoice: _vm.invoice,
                  "scheduled-payments": _vm.invoice.scheduledPayments,
                  account: _vm.account,
                  "edit-mode": false,
                  "attachment-service": _vm.invoiceService,
                  "invoice-service": _vm.invoiceService,
                  appearance: _vm.effectiveAppearance
                },
                on: { "pay-now": _vm.goToPaymentPage }
              })
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }